module.exports = __webpack_public_path__ + "static/media/romskip.5a61cf3b.m4a";